// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__JPZA2","shadowed2":"Navbar_shadowed2__rSMYL","active":"Navbar_active__l7FQP","link":"Navbar_link__clc6E"};